import { Button, Col, Row } from "antd";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Route, RouteChildrenProps } from "react-router";
import { ROUTE_PATHS } from "../../../constants/url-config";
import { setTitle } from "../../../redux/actions/header.action";
import { AppState } from "../../../redux/store";
import {
  OptimizationIcon,
  ResearchIcon,
  SettingIcon,
  StatisticModuleIcon,
} from "../../atoms/icon";
import "./home.scss";
import { Link } from "react-router-dom";
import i18n from "../../../utils/i18n";

const modules = [
  {
    name: i18n.t("BBALM.headerTitle"),
    icon: ResearchIcon,
    description: i18n.t("BBALM.bbAlmDescription"),
    active: true,
    link: ROUTE_PATHS.BBALM,
    points: [
      { name: i18n.t("BBALM.assetLiabilityManagement"), link: ROUTE_PATHS.AssetLiability },
      {
        name: i18n.t("BBALM.marginManagementFtp"),
        link: ROUTE_PATHS.FundsTransferPricing,
      },
      { name: i18n.t("BBALM.alcoReporting"), link: ROUTE_PATHS.BBALMALCO },
      {
        name: i18n.t("BBALM.capitalAdequacyRatio"),
        link: ROUTE_PATHS.CapitalAdequacyRatio,
      },
      {
        name: i18n.t("BBALM.financialPlanningForecasts"),
        link: ROUTE_PATHS.FinancialPlanningForecasts,
      },
      { name: i18n.t("BBALM.investments"), link: ROUTE_PATHS.Investments },
      { name: i18n.t("BBALM.liquidity"), link: ROUTE_PATHS.Liquidity },
      { name: i18n.t("BBALM.securitization"), link: ROUTE_PATHS.Securitization },
    ],
  },
  {
    name: i18n.t("BBERM.headerTitle"),
    icon: StatisticModuleIcon,
    description: i18n.t("BBERM.bbErmDescription"),
    active: true,
    link: ROUTE_PATHS.ECAPLeader,
    points: [
      {
        name: i18n.t("BBERM.scenarioAssetPlanning"),
        link: ROUTE_PATHS.ScenarioFrontierScenarioAndBudgeting,
      },
      { name: i18n.t("BBERM.creditConcentrationStressTesting"), link: ROUTE_PATHS.BBERM_StressTesting },
      { name: i18n.t("BBERM.creditScoringModels"), link: ROUTE_PATHS.CreditScoring },
      { name: i18n.t("BBERM.kriKciRepository"), link: ROUTE_PATHS.BBERM_KRI_KCI_Repo },
      { name: i18n.t("BBERM.strategicIfrs"), link: ROUTE_PATHS.StrategicIFRS },
      { name: i18n.t("BBERM.resilienceDashboard"), link: ROUTE_PATHS.ERMModule },
      { name: i18n.t("BBERM.economicCapital"), link: ROUTE_PATHS.ECAPModule },
      {
        name: i18n.t("BBERM.loanBookLifetimeIncomeAnalysis"),
        link: ROUTE_PATHS.PortfolioRAROCModule,
      },
    ],
  },
  {
    name: i18n.t("BBMRM.headerTitle"),
    icon: OptimizationIcon,
    description: i18n.t("BBMRM.bbMrmDescription"),
    active: true,
    points: [
      { name: i18n.t("BBMRM.modelsRepository"), link: ROUTE_PATHS.ModelsRepository },
      { name: i18n.t("BBMRM.parametricTesting"), link: ROUTE_PATHS.ParametricTesting },
      { name: i18n.t("BBMRM.challengerModelTesting"), link: ROUTE_PATHS.ChallengerModelTesting },
      { name: i18n.t("BBMRM.interestRiskModelTesting"), link: ROUTE_PATHS.InterestRiskModelTesting },
    ],
  },
  {
    name: i18n.t("BBAI.headerTitle"),
    icon: OptimizationIcon,
    description: i18n.t("BBAI.bbAIDescription"),
    active: false,
  },
];

interface Props extends RouteChildrenProps {}

export default function HomePage(props: Props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const userState = useSelector((state: AppState) => state.userState);

  const gotoLink = (link: string | undefined) => {
    if (link) {
      props.history.push(link);
    }
  };

  useEffect(() => {
    dispatch(setTitle(t("Menu.enterpriseApplications")));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="home-wrapper">
      <Row className="header-page">
        <Col sm={24}>
          <p>
            {t("Login.loggedInAs")} <b>{userState.user?.username}</b>
          </p>
        </Col>
      </Row>

      <Row gutter={[24, 24]}>
        {modules.map((item, index) => (
          <Col span={8} key={index}>
            <div
              className={`space-y-4 module-item${
                item.active ? "" : " item-disabled"
              }`}
              style={{ display: "flex", height: "100%" }}
            >
              <div className="module-item-content">
                <div className="item-head">
                  <div style={{display:"flex", gap:"12px"}}>
                    <item.icon />
                    <h4><a href={item.link} className="item-name">{item.name}</a></h4>
                  </div>
                  {!item.active && <a href="https://nyle-ai.vercel.app" target="_">{t("Global.visitBeta")}</a>}
                </div>
                <p>{item.description}</p>
                <Points points={item.points} />
              </div>

              

              {item.active &&  <Button shape="round" type="default" className="setting-btn">
                <SettingIcon className="svg-icon" />{" "}
                {t("ECAPLeader.btnConfiguration")}
              </Button>}
            </div>
          </Col>
        ))}
        <Col></Col>
      </Row>
    </div>
  );
}

type PointsType = {
  points: { name: string; link?: string }[] | undefined | string[];
};

const Points = ({ points }: PointsType) => {
  return (
    <div>
      {points?.map((point: any, index: React.Key) => (
        <li className="home-link" key={index}>
          <Link to={point.link}>{point.name}</Link>
        </li>
      ))}
    </div>
  );
};
